function InicializaEstadisticas() {
    (function (i, s, o, g, r, a, m) {
        i['GoogleAnalyticsObject'] = r; i[r] = i[r] || function () {
            (i[r].q = i[r].q || []).push(arguments)
        }, i[r].l = 1 * new Date(); a = s.createElement(o),
        m = s.getElementsByTagName(o)[0]; a.async = 1; a.src = g; m.parentNode.insertBefore(a, m)
    })(window, document, 'script', 'js/ua.js', 'ga');

    ga('create', 'UA-39829262-9', 'auto');
    ga('send', 'pageview');
}


function addeventoanalitics(category, action, label, valor) {
    ga('send', 'event', category, action, label, valor);
}